(function(angular) {
    'use strict';

    angular.module('aprima-core').filter('formatNum', [
        'NumUtil',
        formatNum,
    ]);

    function formatNum(
        NumUtil
    ) {
        return NumUtil.format;
    }

})(window.angular);
